export default __webpack_public_path__ + "static/media/51-scott.27756e60.jpg";